import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import NoDataImg from "../../../Assets/img/image 12.png";
import excel from "../../../Assets/img/vector/Vector (3).png";
import printer from "../../../Assets/img/vector/printer.png";

import { IoMdWallet } from "react-icons/io";
import { GiReceiveMoney } from "react-icons/gi";
import { GiMoneyStack } from "react-icons/gi";

import axios from "axios";
import * as XLSX from "xlsx";

import { Button, Modal } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";

const EInfo = () => {
    const [payouts, setPayouts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const userKey = sessionStorage.getItem("pk_user_key");
    const [row, setRow] = useState([]);
    const [show, setShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllPaymentData",
                user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;
            setPayouts(output);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    const getAmount = (row) => {
        if (row.payer_user_key == row.receiver_user_key) {
            return <span className="text-success">+${row.amount}</span>;
        } else if (row.payer_user_key == userKey) {
            return <span className="text-danger">-${row.amount}</span>;
        } else {
            return <span className="text-success">+${row.amount}</span>;
        }
    };
    const getPrintFormatAmount = (row) => {
        if (row.payer_user_key == row.receiver_user_key) {
            return `+$${row.amount}`;
        } else if (row.payer_user_key == userKey) {
            return `-$${row.amount}`;
        } else {
            return `+$${row.amount}`;
        }
    };

    // Function to handle Excel export
    const handleExcelExport = () => {
        const filteredPayouts = payouts.map((payout) => ({
            TransactionID: payout.transaction_id,
            AmountType: payout.currency,
            Amount: getPrintFormatAmount(payout),
            DateandTimeofTransaction: convertDateTime(payout.txn_date),
            Summary: payout.summary,
        }));

        const ws = XLSX.utils.json_to_sheet(filteredPayouts);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Payouts");

        XLSX.writeFile(wb, "payouts.xlsx");
    };

    // Function to handle print functionality
    const handlePrint = () => {
        const printWindow = window.open("", "", "height=600,width=800");
        printWindow.document.write("<html><head><title>Print Payouts</title>");
        printWindow.document.write("</head><body>");

        // Create table to print
        printWindow.document.write("<h2>Payouts</h2>");
        printWindow.document.write(`
            <table border='1'>
                <tr>
                    <th>Transaction Id</th>
                    <th>Amont Type</th>
                    <th>Amount</th>
                    <th>Date and Time of Transaction</th>
                    <th>Summary</th>
                </tr>
        `);
        payouts.forEach((payout) => {
            printWindow.document.write(`
                <tr>
                    <td>${payout.transaction_id}</td>
                    <td>${payout.currency}</td>
                    <td>${getPrintFormatAmount(payout)}</td>
                    <td>${convertDateTime(payout.txn_date)}</td>
                    <td>${payout.summary}</td>
                </tr>
            `);
        });
        printWindow.document.write("</table>");
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const filteredPayouts = useMemo(() => {
        handlePageChange(1);
        return payouts.filter((payout) => {
            const searchLower = searchTerm.toLowerCase();

            return (
                (payout.transaction_id && payout.transaction_id.toLowerCase().includes(searchLower)) ||
                (payout.currency && payout.currency.toLowerCase().includes(searchLower)) ||
                (payout.amount && `${payout.amount}`.toLowerCase().includes(searchLower)) ||
                (payout.txn_date && convertDateTime(payout.txn_date).toLowerCase().includes(searchLower)) ||
                (payout.summary && payout.summary.toLowerCase().includes(searchLower))
            );
        });
    }, [payouts, searchTerm]);

    const ITEMS_PER_PAGE = 10;

    const paginatedMagazines = useMemo(() => {
        const start = (currentPage - 1) * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;
        return filteredPayouts.slice(start, end);
    }, [filteredPayouts, currentPage]);

    const totalPages = Math.ceil(filteredPayouts.length / ITEMS_PER_PAGE);

    const totalEarnings = payouts.reduce((sum, payout) => {
        const amount = parseFloat(payout.amount);
        if (amount > 0 && (payout.payer_user_key === payout.receiver_user_key || payout.payer_user_key !== userKey)) {
            return sum + amount;
        }
        return sum;
    }, 0);

    const requestPaid = payouts.reduce((sum, payout) => {
        const amount = parseFloat(payout.amount);
        const summary = payout.summary || "";

        if (amount > 0 && payout.payer_user_key === userKey && summary.toLowerCase() !== "test payment") {
            return sum + amount;
        }
        return sum;
    }, 0);

    const handleViewDetails = (row) => {
        setRow(row);
        handleShow(true);
    };

    // function convertDateTime(originalDateTime) {
    //     // Create a Date object from the original timestamp
    //     let date = new Date(originalDateTime);

    //     // Adjust the date and time as required
    //     date.setDate(date.getDate() - 283); // Adjust days
    //     date.setHours(date.getHours() - 8); // Adjust hours
    //     date.setMinutes(date.getMinutes() - 23); // Adjust minutes

    //     // Format the date to '28 Jan 2024 11:05 AM' format
    //     const options = {
    //         day: "2-digit",
    //         month: "short",
    //         year: "numeric",
    //         hour: "2-digit",
    //         minute: "2-digit",
    //         hour12: true,
    //     };

    //     // Format the adjusted date
    //     return new Intl.DateTimeFormat("en-US", options).format(date).replace(",", "");
    // }

    function convertDateTime(originalDateTime) {
        // Create a Date object from the original timestamp (assuming it's in UTC)
        let date = new Date(originalDateTime);

        // Adjust the date if necessary (e.g., use the following only if needed)
        // date.setDate(date.getDate() - 283); // Adjust days
        // date.setHours(date.getHours() - 8); // Adjust hours
        // date.setMinutes(date.getMinutes() - 23); // Adjust minutes

        // Format the date to '28 Jan 2024 11:05 AM' format
        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };

        // Format the adjusted date
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(",", "");
    }

    return (
        <>
            <section className="pb-3">
                <div className="main-content">
                    <h3 className="page-title">E-wallet</h3>
                    <div className="row g-2">
                        {/* <div className="col-md-12 col-lg-3 px-2">
            <div className="head-box p-3 d-flex">
              <div className="icon-box bg-white rounded-3">
                <IoMdWallet className="f-32" />
              </div>
              <div className="box px-2">
                <div className="text-box">
                  <p>Balance</p>
                  <span className="head-box-count">$400.00</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-3 px-2">
            <div className="head-box p-3 d-flex">
              <div className="icon-box bg-white rounded-3">
                <svg
                  width="69"
                  height="68"
                  viewBox="0 0 69 68"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.666992"
                    width="68"
                    height="68"
                    rx="7"
                    fill="white"
                  />
                  <path
                    d="M44.2582 37.3335C45.5582 37.3335 46.7032 37.9951 47.3748 39.0001H37.1665C36.0614 39.0001 35.0016 39.4391 34.2202 40.2205C33.4388 41.0019 32.9998 42.0617 32.9998 43.1668V49.8335C32.9998 50.1035 33.0248 50.3657 33.0748 50.6201C28.1765 50.3101 24.5148 48.5368 22.1915 45.2751C21.6378 44.4987 21.3401 43.5688 21.3398 42.6151V41.0818C21.3403 40.0878 21.7353 39.1347 22.4382 38.4318C23.141 37.729 24.0942 37.3339 25.0882 37.3335H44.2582ZM34.6665 17.3418C35.7609 17.3418 36.8445 17.5573 37.8555 17.9761C38.8666 18.3949 39.7852 19.0088 40.5591 19.7826C41.3329 20.5564 41.9467 21.4751 42.3655 22.4861C42.7843 23.4971 42.9998 24.5808 42.9998 25.6751C42.9998 26.7695 42.7843 27.8531 42.3655 28.8642C41.9467 29.8752 41.3329 30.7939 40.5591 31.5677C39.7852 32.3415 38.8666 32.9553 37.8555 33.3741C36.8445 33.7929 35.7609 34.0085 34.6665 34.0085C32.4564 34.0085 30.3368 33.1305 28.774 31.5677C27.2111 30.0049 26.3332 27.8853 26.3332 25.6751C26.3332 23.465 27.2111 21.3454 28.774 19.7826C30.3368 18.2198 32.4564 17.3418 34.6665 17.3418ZM34.6665 43.1668C34.6665 42.5038 34.9299 41.8679 35.3987 41.399C35.8676 40.9302 36.5035 40.6668 37.1665 40.6668H50.4998C51.1629 40.6668 51.7988 40.9302 52.2676 41.399C52.7364 41.8679 52.9998 42.5038 52.9998 43.1668V49.8335C52.9998 50.4965 52.7364 51.1324 52.2676 51.6012C51.7988 52.0701 51.1629 52.3335 50.4998 52.3335H37.1665C36.5035 52.3335 35.8676 52.0701 35.3987 51.6012C34.9299 51.1324 34.6665 50.4965 34.6665 49.8335V43.1668ZM51.3332 44.0001C50.8911 44.0001 50.4672 43.8245 50.1547 43.512C49.8421 43.1994 49.6665 42.7755 49.6665 42.3335H47.9998C47.9998 43.2175 48.351 44.0654 48.9762 44.6905C49.6013 45.3156 50.4491 45.6668 51.3332 45.6668V44.0001ZM51.3332 47.3335C50.4491 47.3335 49.6013 47.6847 48.9762 48.3098C48.351 48.9349 47.9998 49.7827 47.9998 50.6668H49.6665C49.6665 50.2248 49.8421 49.8008 50.1547 49.4883C50.4672 49.1757 50.8911 49.0001 51.3332 49.0001V47.3335ZM37.9998 42.3335C37.9998 42.7755 37.8242 43.1994 37.5117 43.512C37.1991 43.8245 36.7752 44.0001 36.3332 44.0001V45.6668C37.2172 45.6668 38.0651 45.3156 38.6902 44.6905C39.3153 44.0654 39.6665 43.2175 39.6665 42.3335H37.9998ZM39.6665 50.6668C39.6665 49.7827 39.3153 48.9349 38.6902 48.3098C38.0651 47.6847 37.2172 47.3335 36.3332 47.3335V49.0001C36.7752 49.0001 37.1991 49.1757 37.5117 49.4883C37.8242 49.8008 37.9998 50.2248 37.9998 50.6668H39.6665ZM46.7498 46.5001C46.7498 45.7266 46.4426 44.9847 45.8956 44.4377C45.3486 43.8908 44.6067 43.5835 43.8332 43.5835C43.0596 43.5835 42.3178 43.8908 41.7708 44.4377C41.2238 44.9847 40.9165 45.7266 40.9165 46.5001C40.9165 47.2737 41.2238 48.0155 41.7708 48.5625C42.3178 49.1095 43.0596 49.4168 43.8332 49.4168C44.6067 49.4168 45.3486 49.1095 45.8956 48.5625C46.4426 48.0155 46.7498 47.2737 46.7498 46.5001Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div className="box px-2">
                <div className="text-box">
                  <p>Referral Balance</p>
                  <span className="head-box-count">$130.00</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-3 px-2">
            <div className="head-box p-3 d-flex">
              <div className="icon-box bg-white rounded-3">
                <GiReceiveMoney className="f-32" />
              </div>
              <div className="box px-2">
                <div className="text-box">
                  <p>Bonus Earnings</p>
                  <span className="head-box-count">$120.00</span>
                </div>
              </div>
            </div>
          </div> */}
                        <div className="col-md-12 col-lg-3 px-2">
                            <div className="head-box p-3 d-flex">
                                <div className="icon-box bg-white rounded-3">
                                    <GiMoneyStack className="f-32" />
                                </div>
                                <div className="box px-2">
                                    <div className="text-box">
                                        <p>Total Earnings</p>
                                        {/* <span className="head-box-count">$650.00</span> */}
                                        <span className="head-box-count">${totalEarnings.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-3 px-2">
                            <div className="head-box p-3 d-flex">
                                <div className="icon-box bg-white rounded-3">
                                    <GiReceiveMoney className="f-32" />
                                </div>
                                <div className="box px-2">
                                    <div className="text-box">
                                        <p>Total Paid Amount</p>
                                        <span className="head-box-count">${requestPaid.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 px-2">
                            <div className="m-wrapper mt-3 p-3">
                                <div className="input-group mb-3 d-flex gap-3 align-items-center justify-content-between">
                                    <div className="net-input-field">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <div className="net-input-field">
                                        <button
                                            className="btn btn-dark border border-dark ms-2 download-btn rounded-2"
                                            type="button"
                                            onClick={handleExcelExport}
                                        >
                                            <img src={excel} className="img-fluid pe-1 pb-1" alt="" />
                                            Excel
                                        </button>
                                        <button className="btn btn-dark border border-dark ms-2 download-btn rounded-2" type="button" onClick={handlePrint}>
                                            <img src={printer} className="img-fluid pe-1 pb-1" alt="" />
                                            Print
                                        </button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th className="bg-5">Transaction ID</th>
                                                <th className="bg-5">Amount Type</th>
                                                <th className="bg-5">Amount</th>
                                                <th className="bg-5">Date of Transaction</th>
                                                <th className="bg-5">Summary</th>
                                                <th className="bg-5">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedMagazines.length > 0 ? (
                                                paginatedMagazines.map((payout) => (
                                                    <tr key={payout.pk_pay_key}>
                                                        <td>{payout.transaction_id}</td>
                                                        <td>{payout.currency}</td>
                                                        {/* <td>${payout.amount}</td> */}
                                                        <td>{getAmount(payout)}</td>
                                                        {/* <td>{formatDate(payout.created_on)}</td> */}
                                                        <td>{convertDateTime(payout.txn_date)}</td>
                                                        <td>{payout.summary}</td>
                                                        <td>
                                                            <Tooltip title="View Details">
                                                                <Button variant="outline-dark" size="sm" onClick={() => handleViewDetails(payout)}>
                                                                    <i class="fa-sharp fa-solid fa-eye"></i>
                                                                </Button>
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        <div className="d-flex flex-column align-items-center">
                                                            <img src={NoDataImg} alt="No data" className="img-fluid" />
                                                            <span>No Data available</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="pagination d-flex justify-content-end mb-3 my-3">
                                        <Button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                                            &lt;&lt;
                                        </Button>
                                        <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                                            &lt;
                                        </Button>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <Button
                                                key={index + 1}
                                                onClick={() => handlePageChange(index + 1)}
                                                className={`mx-1 ${currentPage === index + 1 ? "btn-dark text-white" : "btn-light"}`}
                                            >
                                                {index + 1}
                                            </Button>
                                        ))}
                                        <Button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="btn btn-light mx-1"
                                        >
                                            &gt;
                                        </Button>
                                        <Button
                                            onClick={() => handlePageChange(totalPages)}
                                            disabled={currentPage === totalPages}
                                            className="btn btn-light mx-1"
                                        >
                                            &gt;&gt;
                                        </Button>
                                    </div>
                                </div>

                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Payer & Receiver Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {/* <h6>Payer Details:</h6>
                                      <h6>Receiver Details:</h6> */}
                                        <p>
                                            <strong>Transaction ID:</strong> {row.transaction_id && row.transaction_id}
                                        </p>

                                        <p>
                                            <strong>Summary:</strong> {row.summary && row.summary}
                                        </p>
                                        <p>
                                            <strong>Payer ID:</strong> {row.payer_id && row.payer_id}
                                        </p>
                                        <p>
                                            <strong>Payer Email:</strong> {row.payer_email && row.payer_email}
                                        </p>

                                        {row.pk_sub_key && (
                                            <>
                                                <p>
                                                    <strong>Subscriped Plan:</strong> {row.sub_name}
                                                </p>
                                                <p>
                                                    <strong>Plan Validity:</strong> {row.sub_month == 1 ? row.sub_month + " month" : row.sub_month + " months"}
                                                </p>
                                                <p>
                                                    <strong>Subscriped Date & Time:</strong> {convertDateTime(row.start_date)}
                                                </p>
                                                <p>
                                                    <strong>Renewable Date & Time:</strong> {convertDateTime(row.end_date)}
                                                </p>
                                            </>
                                        )}

                                        <p>
                                            <strong>Receiver Email:</strong> {row.receiver_email && row.receiver_email}
                                        </p>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>
                                        {/* <Button variant="secondary">
                                            <Link to={row.payer_user_key ? `/admin/user/edit/${row.payer_user_key}` : "#"} className="text-white">
                                                View Payer
                                            </Link>
                                        </Button> */}
                                    </Modal.Footer>
                                </Modal>
                                <style jsx>
                                    {`
                                        .download-btn {
                                            width: 92px;
                                        }

                                        .net-input-field input,
                                        select {
                                            width: 252px !important;
                                            height: 42px;
                                            padding: 11px;
                                            border-radius: 4px;
                                            outline: none;
                                            transition: border-color 0.3s;
                                        }
                                        .w-90 {
                                            width: 90%;
                                        }
                                        .money-box {
                                            background-color: #d9d9d9 !important;
                                        }
                                        .money-box-count {
                                            font-weight: 600;
                                        }
                                    `}
                                </style>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EInfo;
